
//language selector
$('.js-localization-selector-wrapper').click(function(e){
  e.preventDefault();
  let $modal_wrapper = $(this).find('.localization-form-modal-wrapper')
  if(!$modal_wrapper.hasClass('open')){
    
    $(document).on("click.language-selector-wrapper", function (event) {
      let $modal = $('.localization-form-modal-wrapper');
      if ($modal.hasClass("open") && !$(event.target).closest(".localization-form-modal-container").length) {
        handleLocalizationModalClose();
      }
    });
    $modal_wrapper.addClass('open');
    e.stopPropagation();
    e.preventDefault();
  }
})

$('.js-localization-form-modal-close').click(function(e){
  e.preventDefault();
  e.stopPropagation();
  handleLocalizationModalClose();
  
})

function handleLocalizationModalClose(){
  
  $(document).off('.language-selector-wrapper');
  $('.localization-form-modal-wrapper').removeClass('open');
}


$('[name="localization-country"],[name="localization-language"]').change(function(e){
  let $form = $(this).parents('#localization_form');
  let locale = $form.find('.modal_locale_code');
  let country = $form.find('.modal_country_code');

  country.val($form.find('[name="localization-country"]').val());
  locale.val($form.find('[name="localization-language"]').val());
  //$form.submit();
})

$('.js-localization-form-submit').click(function(e){
  //e.preventDefault();
  let $form = $(this).parents('#localization_form');
  $form.trigger( "submit" );
  $form.submit();

})